import { QueryKey, UseQueryResult, useQuery } from '@tanstack/react-query'

import { graphierQL } from 'utils'
import {
  GetCategoryTagsQuery,
  GetCategoryTagsQueryVariables
} from '~explore/types/__generated/gql/graphql'

export const getCategoryTagsQuery = /* GraphQL */ `
  query GetCategoryTags($size: Int!, $categoryTypes: [CATEGORY_TAG_TYPE!]!) {
    searchTags(size: $size, categoryTypes: $categoryTypes) {
      id
      createdAt
      updatedAt
      name
      thumbnail
      categoryType
    }
  }
`

type GetCategoryTagsVariables = GetCategoryTagsQueryVariables
type GetCategoryTagsResults = GetCategoryTagsQuery['searchTags']

const getCategoryTagsQueryKey = (
  variables: GetCategoryTagsVariables
): QueryKey => {
  return ['getCategoryTags', variables]
}

const getCategoryTags = (variables: GetCategoryTagsVariables) =>
  graphierQL<GetCategoryTagsQuery>({
    query: getCategoryTagsQuery,
    variables
  }).then((res) => res.searchTags)

const useGetCategoryTags = (
  variables: GetCategoryTagsVariables
): UseQueryResult<GetCategoryTagsResults> => {
  return useQuery({
    queryKey: getCategoryTagsQueryKey(variables),
    queryFn: () => getCategoryTags(variables)
  })
}

export { getCategoryTags, getCategoryTagsQueryKey, useGetCategoryTags }
export type { GetCategoryTagsResults, GetCategoryTagsVariables }
